<script lang="ts">
  import type { ManageAPI } from "~/manage-api/types";
  import type { Translator } from "~/service/l10n";
  import { parseExceptionalOpeningHoursItem, parseOpeningHoursItem } from "~/util/date-n-time";

  export let locale: string;
  export let item: ManageAPI.OpeningHoursItem | ManageAPI.ExceptionalOpeningHoursItem;
  export let t: Translator;
  export let opening_hours: ManageAPI.OpeningHoursItem[];
  export let status: ManageAPI.OpeningStatus | undefined = undefined;

  let ranges: string[] = [];

  $: if ('days' in item) {
    status = item.openingStatus;
    if (status === 'CLOSED' && opening_hours !== undefined) {
      const isTemporaryClosedStore: boolean = opening_hours.length > 0 && opening_hours.every(x => x.openingStatus == 'CLOSED');
      if (isTemporaryClosedStore) status = 'TEMPORARY_CLOSED';
    }
    ranges = parseOpeningHoursItem(locale, item);
  }
  $: if ('reason' in item) {
    status = item.open ? 'OPEN' : 'CLOSED';
    ranges = item.open ? [parseExceptionalOpeningHoursItem(locale, item)] : [];
  }
</script>

{#each ranges as range, index}
  {#if index}, {/if}
  {range}
  {:else}
  {t(`store.status.${status}`)}
{/each}
